import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { ROUTES } from '@utils/constants';
import { UserStateService } from '../services/state/user-state.service';

/**
 * Changes root route based on user's role.
 * E.g navigating to `localhost:4200` redirects to `localhost:4200/auth` when not logged in.
 */
@Injectable({
  providedIn: 'root',
})
export class RedirectRouteGuard {
  constructor(
    private router: Router,
    private userStateService: UserStateService,
  ) {}

  public canActivate(): Observable<UrlTree> {
    return this.userStateService.checkUserPermissions().pipe(
      take(1),
      map((role) => {
        let route = `/${ROUTES.app.home.path}`;
        if (role.isAdmin) {
          route = `/${ROUTES.admin.root}`;
          // } else if (role.isTeacher && !role.hasAcceptedTeacherAgreement) {
          //   route = `/${ROUTES.user.teacherAgreement.path}`;
        } else if (role.isTeacher) {
          route = `/${ROUTES.teacher.root}`;
          // } else if (role.isStudent && !role.hasAcceptedStudentAgreements) {
          //   route = `/${ROUTES.user.tudentAgreement.path}`;
        } else if (role.isStudent && !role?.isEnrolled) {
          route = '/student/classes';
        } else if (role.isStudent && role?.isEnrolled) {
          route = `/${ROUTES.student.root}`;
        }
        return this.router.parseUrl(route);
      }),
    );
  }
}
